import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TechMarquee from "@/components/landing/TechMarquee";
import Services from "@/components/landing/Services";
import Cases from "@/components/landing/Cases";
import Process from "@/components/landing/Process";
import Testimonials from "@/components/landing/Testimonials";
import FAQSection from "@/components/landing/FAQSection";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="relative bg-[#050505] text-white overflow-x-hidden">
      <div className="noise-overlay" />
      <Navbar />
      <Hero />
      <TechMarquee />
      <Services />
      <Cases />
      <Process />
      <Testimonials />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default LandingPage;
